import { Stack, Typography, Box, Divider, useTheme } from '@mui/material';

import { Routes } from '@core/constants/routes';

import BackButton, { BackButtonProps } from '../back-button/back-button';
import { Title, TitleProps } from '../title';

export interface PageHeaderProps {
  title: string;
  titleProps?: TitleProps;
  subtitle?: string;
  imgSrc?: string;
  hideBackButton?: boolean;
  hideDivider?: boolean;
  backLink?: Routes | Routes[];
  backLinkOpts?: BackButtonProps['options'];
  onBackClick?: () => void;
  loading?: boolean;
}

export const PageHeader = ({
  title,
  subtitle,
  titleProps,
  imgSrc,
  hideBackButton,
  hideDivider,
  backLink,
  backLinkOpts,
  loading,
  onBackClick,
}: PageHeaderProps) => {
  const theme = useTheme();
  return (
    <Stack>
      <Stack
        flexDirection='row'
        justifyContent='space-between'
        sx={{
          px: { md: 1 },
          width: '100%',
          bgcolor: 'white',
        }}
      >
        <Stack alignItems='flex-start' width='100%'>
          {!hideBackButton ? (
            <BackButton
              backLink={backLink}
              onClick={onBackClick}
              options={backLinkOpts}
            />
          ) : (
            <Box
              sx={{
                height: 0,
                minHeight: 0,
                width: 2.5,
                mt: 2.5,
                display: { xs: 'block', md: 'none' },
              }}
            />
          )}

          <Title {...(titleProps ?? {})} loading={loading}>
            {title}
          </Title>
          {subtitle && (
            <Typography
              fontSize={20}
              sx={{ mb: 1, mt: 0.5 }}
              color={theme.palette.primary.dark}
            >
              {subtitle}
            </Typography>
          )}
        </Stack>
        {imgSrc && (
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <img
              src={imgSrc}
              alt='Header image'
              width={325}
              height={170}
              className='min-w-[325px] h-[170px]'
            />
          </Box>
        )}
      </Stack>
      {!hideDivider && <Divider />}
    </Stack>
  );
};
